/**
 * User Info constants
 */
export const RECEIVE_USER_INFO = 'RECEIVE_USER_INFO'
export const RECEIVE_USER_COMPANY = 'RECEIVE_USER_COMPANY'
export const FETCH_USER_COMPANY = 'FETCH_USER_COMPANY'
export const FETCH_GLOBAL_CONTROLS = 'FETCH_GLOBAL_CONTROLS'
export const RECEIVE_GLOBAL_CONTROLS = 'RECEIVE_GLOBAL_CONTROLS'
export const CLOSE_RELEASE_NOTES_MODAL = 'CLOSE_RELEASE_NOTES_MODAL'
